export default "/images/8b28a0df04b256b459e82c299cedbf68.avif";